import { useHttp } from '@/composable/service/useHttp';
import userHttp, { UserRegisterForm } from '@/services/http/user.http';
import md5 from 'md5';
import useAsyncState from '@/composable/service/useAsyncState';
import { useAnalyticDecodeFc } from '@/composable/controller/useAnalytic';
import useTemporaryUserRegister from '@/composable/states/useTemporaryUserState';

export default function useUserRegister(encodedFcId?: string) {
  const { setTemporaryUser } = useTemporaryUserRegister();
  const decodeFc = useAnalyticDecodeFc();
  const http = useHttp(userHttp.register);
  async function registerUser(form: UserRegisterForm) {
    if (encodedFcId) {
      const { decodedId } = await decodeFc.request({ encodedId: encodedFcId });
      setTemporaryUser({
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        tel: form.tel,
        shop: {
          id: decodedId,
        },
      });
    }
    const newForm: UserRegisterForm = { ...form, password: md5(form.password) };
    return http.request(newForm);
  }
  const asyncState = useAsyncState(registerUser);
  return {
    registerUser: asyncState.request,
    registerUserLoading: asyncState.loading,
    registerUserError: asyncState.error,
  };
}
